import React from 'react';
import { TextField } from '@mui/material';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';

const StyledTextField = styled(TextField, {
  shouldForwardProp: (prop) => prop !== 'textFieldVariant',
})(({ theme, textFieldVariant }) => {
  const variants = {
    default: {
      // Uses theme defaults
    },
    auth: {
      '& .MuiOutlinedInput-root': {
        borderRadius: theme.spacing(2),
        fontSize: '1.1rem',
        padding: '2px 8px',
        '&:hover': {
          transform: 'translateY(-2px)',
          boxShadow: `0 4px 12px ${theme.palette.primary.main}20`,
        },
        '&.Mui-focused': {
          transform: 'translateY(-2px)',
          boxShadow: `0 4px 12px ${theme.palette.primary.main}40`,
        },
      },
      '& .MuiInputLabel-root': {
        fontSize: '1.1rem',
        fontWeight: 500,
      },
    },
    form: {
      '& .MuiOutlinedInput-root': {
        fontSize: '0.95rem',
        borderRadius: 0,
        '&:hover': {
          transform: 'translateY(-1px)',
          boxShadow: `0 2px 8px ${theme.palette.primary.main}15`,
        },
        '&.Mui-focused': {
          transform: 'translateY(-1px)',
        },
      },
    },
    search: {
      '& .MuiOutlinedInput-root': {
        borderRadius: theme.spacing(3),
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        '&:hover': {
          backgroundColor: '#ffffff',
          boxShadow: `0 2px 8px ${theme.palette.primary.main}20`,
        },
        '&.Mui-focused': {
          backgroundColor: '#ffffff',
          boxShadow: `0 4px 12px ${theme.palette.primary.main}30`,
        },
      },
    },
    compact: {
      '& .MuiOutlinedInput-root': {
        fontSize: '0.875rem',
        '& input': {
          padding: '8px 12px',
        },
      },
      '& .MuiInputLabel-root': {
        fontSize: '0.875rem',
      },
    },
  };

  return variants[textFieldVariant] || variants.default;
});

const EasyCheckTextField = React.forwardRef(({ 
  variant = 'default',
  children,
  ...props 
}, ref) => {

  return (
    <StyledTextField
      ref={ref}
      variant="outlined"
      fullWidth
      textFieldVariant={variant}
      {...props}
    >
      {children}
    </StyledTextField>
  );
});

EasyCheckTextField.propTypes = {
  variant: PropTypes.oneOf(['default', 'auth', 'form', 'search', 'compact']),
  children: PropTypes.node,
};

EasyCheckTextField.displayName = 'EasyCheckTextField';

export default EasyCheckTextField; 